import { render, staticRenderFns } from "./MentionSuggestionRichText.vue?vue&type=template&id=1c6cf98b&scoped=true&"
import script from "./MentionSuggestionRichText.vue?vue&type=script&lang=js&"
export * from "./MentionSuggestionRichText.vue?vue&type=script&lang=js&"
import style0 from "./MentionSuggestionRichText.vue?vue&type=style&index=0&id=1c6cf98b&prod&lang=scss&"
import style1 from "./MentionSuggestionRichText.vue?vue&type=style&index=1&id=1c6cf98b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6cf98b",
  null
  
)

export default component.exports